// @flow

import React, { Fragment, useEffect, useState } from 'react';

import { Survey } from '@zapier/design-system-marketing-and-paid';
import { isOffSite } from '@zapier/common-utils';

import TrackData from 'app/track/Data';
import maybeRenderIfAbTest from 'app/common/components/maybeRenderIfAbTest';
import { getJson } from 'app/common/fetch';

import useLocalStorage from './useLocalStorage';
import useScreenSize from './useScreenSize';

const POPUP_SURVEY_LOCALSTORAGE_KEY = 'zapier__popup-survey';
const EXPERIMENT_NAME = 'popup-survey';
const SURVEY_EVENTS = {
  shown: 'shown',
  dismissed: 'dismissed',
  completed: 'completed',
};

function trackOnMount() {
  TrackData.recordUserPopupSurvey('', SURVEY_EVENTS.shown);
}

const HomepageSurveyContainer = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [userHasSignedUp, setUserHasSignedUp] = useState(true);
  const [surveySentSuccessfully, setSurveySentSuccessfully] = useState(false);
  const [
    showPopupFromLocalStorage,
    setShowPopupFromLocalStorage,
  ] = useLocalStorage(POPUP_SURVEY_LOCALSTORAGE_KEY);
  const size = useScreenSize();

  async function getUserHasSignedUp() {
    /**
     * @alejandro
     * This will be refactored and moved to the proxy in MP-82
     * We didn't move this as part of MP-44 due to time constraints
     */
    const { has_signed_up: hasSignedUP } = await getJson('/api/v4/identity/');
    setUserHasSignedUp(hasSignedUP);
  }

  useEffect(() => {
    getUserHasSignedUp();
  }, []);

  useEffect(() => {
    if (showPopupFromLocalStorage === null && !userHasSignedUp) {
      setShowPopup(true);
    }
  }, [showPopupFromLocalStorage, userHasSignedUp]);

  function hidePopup() {
    setShowPopupFromLocalStorage(false);
    setShowPopup(false);
  }

  function dismissPopup() {
    hidePopup();
    TrackData.recordUserPopupSurvey('', SURVEY_EVENTS.dismissed);
  }

  function handleSubmission(value: string) {
    TrackData.recordUserPopupSurvey(value, SURVEY_EVENTS.completed);
    setSurveySentSuccessfully(true);
  }

  function closeOnSuccess() {
    hidePopup();
  }

  return (
    <Fragment>
      {showPopup ? (
        <Survey
          dismissPopup={dismissPopup}
          dismissPopupOnClose={closeOnSuccess}
          onMount={trackOnMount}
          onSubmit={handleSubmission}
          size={size}
          surveySentSuccessfully={surveySentSuccessfully}
        />
      ) : null}
    </Fragment>
  );
};

const OnSiteOnly = () => (isOffSite() ? null : <HomepageSurveyContainer />);

export default maybeRenderIfAbTest(EXPERIMENT_NAME, 'treatment')(OnSiteOnly);
